module.exports = __webpack_public_path__ + "static/pullrequests.a14ac403.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/pullrequests.png
// module id = ./src/pages/index/pullrequests.png
// module chunks = 2345137460201621000 13254968351354405000 17463659626562118000